import { EditorComponentDefinition } from './types';
import { achievementsHistoryTableV2ComponentDefinition } from './transaction-history-v2/transaction-history-table-v2-grapes-component';
import { achievementsHistoryV2ComponentDefinition } from './transaction-history-v2/transaction-history-v2-grapes-component';
import { advancedFormatComponentDefinition } from './advanced-format/advanced-format-grapes-component';
import { buttonComponentDefinition } from './button-grapes-component';
import { campaignCardComponentDefinition } from './campaign-card/campaign-card-grapes-component';
import { campaignCardsFeedComponentDefinition } from './campaign-cards-feed/campaign-cards-feed-grapes-component';
import { columnComponentDefinition } from './columns/column-component';
import { currencyCounterComponentDefinition } from './currency-counter/currency-counter-grapes-component';
import { customHtmlComponentDefinition } from './custom-html-component/custom-html-component';
import { embeddedMediaComponentDefinition } from './embedded-media/embedded-media-component';
import { imageComponentDefinition } from './image-component';
import { interactionsListComponentDefinition } from './interactions-list/interactions-list-grapes-component';
import { leaderboardComponentDefinition } from './leaderboard/leaderboard-grapes-component';
import { leaderboardTableComponentDefinition } from './leaderboard/leaderboard-table-grapes-component';
import { leaderboardV2ComponentDefinition } from './leaderboard-v2/leaderboard-v2-grapes-component';
import { leaderboardV2TableComponentDefinition } from './leaderboard-v2/leaderboard-v2-table-grapes-component';
import { levelV2ComponentDefinition } from './level-v2/level-v2-grapes-component';
import { linkComponentDefinition } from './link/link-grapes-component';
import {
  navigationComponentDefinition,
  navigationContainerComponentDefinition,
} from './navigation-grapes-component';
import { oneColumnComponentDefinition } from './columns/one-column-component';
import { profileV2ComponentDefinition } from './profile-v2/profile-v2-grapes-component';
import { qrCodeComponentDefinition } from './qrcode/qrcode-grapes-component';
import { referralCodeComponentDefinition } from './referral/referral-code-grapes-component';
import { referralDataGrapesComponentDefinition } from './referral/referral-data-grapes-component';
import { rewardsComponentDefinition } from './rewards/rewards-grapes-component';
import { rewardsListComponentDefinition } from './rewards/rewards-list-grapes-component';
import { rewardsWonComponentDefinition } from './rewards-won/rewards-won-grapes-component';
import { rewardsWonTableComponentDefinition } from './rewards-won/rewards-won-table-grapes-component';
import { rssComponentDefinition } from './rss/rss-grapes-component';
import { subTitleComponentDefinition } from './sub-title-component';
import {
  tabsComponentDefinition,
  tabsContainerComponentDefinition,
} from './tabs/tabs-grapes-component';
import { textComponentDefinition } from './text-component';
import { threeColumnsComponentDefinition } from './columns/three-columns-component';
import { titleComponentDefinition } from './title-component';
import { twoColumnsComponentDefinition } from './columns/two-columns-component';

export const editorComponentsDefinitions: EditorComponentDefinition[] = [
  columnComponentDefinition,
  titleComponentDefinition,
  subTitleComponentDefinition,

  // Basic
  oneColumnComponentDefinition,
  twoColumnsComponentDefinition,
  threeColumnsComponentDefinition,
  tabsComponentDefinition,
  tabsContainerComponentDefinition,
  navigationComponentDefinition,
  navigationContainerComponentDefinition,

  // Content
  profileV2ComponentDefinition,
  leaderboardComponentDefinition,
  leaderboardV2ComponentDefinition,
  levelV2ComponentDefinition,
  campaignCardComponentDefinition,
  campaignCardsFeedComponentDefinition,
  rewardsComponentDefinition,
  rewardsWonComponentDefinition,
  achievementsHistoryV2ComponentDefinition,
  interactionsListComponentDefinition,
  currencyCounterComponentDefinition,
  referralCodeComponentDefinition,
  textComponentDefinition,
  imageComponentDefinition,
  linkComponentDefinition,
  customHtmlComponentDefinition,
  rssComponentDefinition,
  embeddedMediaComponentDefinition,
  buttonComponentDefinition,
  qrCodeComponentDefinition,
  advancedFormatComponentDefinition,

  // Sub-parts
  leaderboardTableComponentDefinition,
  leaderboardV2TableComponentDefinition,
  achievementsHistoryTableV2ComponentDefinition,
  referralDataGrapesComponentDefinition,
  rewardsListComponentDefinition,
  rewardsWonTableComponentDefinition,
];
